export const AUTH_INVALID_EVENT = 'nbh:auth:invalid';

export type AuthInvalidEventDetail = { status: number };
